// How a report's sections are arranged — shared by the on-screen view and the
// printed sheet, so the preview cannot be laid out differently from the paper.
//
// One rule, and it exists because a COUNT table is not a DATA table. "Pieces by
// device type" is three narrow columns and five rows; stretched across a full
// A4 it is 90% whitespace with a lonely number at the right margin, which is
// what made the inventory sheet look broken rather than sparse. Two of them
// side by side read as a summary block, which is what they are.

/**
 * Group consecutive `compact` sections into rows, leaving everything else
 * full-width.
 *
 * -> [{ compact: bool, sections: [...] }] in the original order.
 *
 * Consecutive, not "all compact sections": order is meaning here. A summary
 * that comes after the table it summarises must stay after it.
 */
export function groupSections(sections) {
  const out = [];
  (sections || []).forEach((s) => {
    const last = out[out.length - 1];
    if (s.compact && last && last.compact) {
      last.sections.push(s);
      return;
    }
    out.push({ compact: !!s.compact, sections: [s] });
  });
  return out;
}

export default groupSections;
